<template>
  <div class="r-base64">
    <label class="label">{{ label }}</label>
    <div
      class="dropzone"
      @click="triggerFile"
      @dragover.prevent
      @dragenter.prevent
      @drop.prevent="onDrop"
    >
      <div v-if="value" class="preview">
        <img :src="value" alt="preview" />
      </div>
      <div v-else class="placeholder">
        <i class="f7-icons">photo_fill</i>
        <div class="text">Arrastra una imagen o haz click</div>
      </div>
    </div>
    <div class="actions">
      <input ref="fileInput" type="file" accept="image/*" style="display:none" @change="onFileChange" />
      <f7-button small @click="triggerFile">Seleccionar</f7-button>
      <f7-button small color="red" @click="clear" v-if="value">Borrar</f7-button>
    </div>
  </div>
</template>

<style scoped>
  .r-base64 .label { display:block; margin-bottom:6px; font-weight:500; }
  .dropzone { border: 1px dashed #ccc; border-radius:6px; padding:8px; display:flex; align-items:center; justify-content:center; min-height:140px; cursor:pointer; background:#fafafa }
  .dropzone .placeholder { text-align:center; color:#666 }
  .dropzone .placeholder .f7-icons { font-size:32px; display:block; margin-bottom:6px }
  .preview img { max-width:100%; max-height:200px; display:block; margin:auto }
  .actions { margin-top:6px; display:flex; gap:6px }
</style>

<script>
export default {
  props: {
    name: { type: String, required: true },
    form: { required: true },
    label: { type: String, default: 'Logo' }
  },
  data() {
    return { value: undefined };
  },
  watch: {
    // Observa cambios en el objeto form.formData para reflejar base64 cargado posteriormente
    'form.formData': {
      handler() {
        this.value = this.getValue();
      },
      deep: true
    }
  },
  methods: {
    getValue() {
      var namespaces = this.name.split('.');
      var context = this.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == 'undefined' || context == null) return undefined;
        context = context[namespaces[i]];
      }
      return context;
    },
    setValue(val) {
      var namespaces = this.name.split('.');
      var context = this.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          this.$set(context, namespaces[i], val);
          this.$emit('change', val, this);
        } else if (context[namespaces[i]] == null) {
          this.$set(context, namespaces[i], {});
        }
        context = context[namespaces[i]];
      }
    },
    triggerFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.readFile(file);
      e.target.value = '';
    },
    onDrop(e) {
      const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!file) return;
      this.readFile(file);
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const base64 = ev.target.result;
        this.value = base64;
        this.setValue(base64);
      };
      reader.readAsDataURL(file);
    },
    clear() {
      this.value = undefined;
      this.setValue(undefined);
    }
  },
  mounted() {
    this.value = this.getValue();
    // Si el valor ya existía antes de montar, asegúrate de sincronizarlo
    this.$nextTick(() => {
      this.value = this.getValue();
    });
  }
};
</script>
